import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h1" sx={{ fontSize: '6rem', fontWeight: 'bold', color: '#e53935' }}>
          404
        </Typography>
        <Typography variant="h5" gutterBottom>
          找不到此頁面
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          您所尋找的頁面可能已被移除、名稱已變更或暫時無法使用。
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={() => navigate('/')}
          >
            回首頁
          </Button>
          <Button
            variant="outlined"
            startIcon={<SearchIcon />}
            onClick={() => navigate('/products')}
          >
            瀏覽商品
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default NotFound;
